/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Seatbelt Parked Icon component.
 */
export const SeatbeltParkedIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_604_44)">
        <path d="M13.5 9.5C13.5 8.5335 12.7165 7.75 11.75 7.75C10.7835 7.75 9.99999 8.5335 9.99999 9.5C9.99999 10.4665 10.7835 11.25 11.75 11.25C12.7165 11.25 13.5 10.4665 13.5 9.5ZM15.6924 15.498C15.9695 15.1902 16.4441 15.1653 16.7519 15.4424C17.5233 16.1368 18.0013 17.0259 18 18.001C17.9994 18.4152 17.6632 18.7505 17.249 18.75C16.8348 18.7495 16.4994 18.4132 16.5 17.999C16.5006 17.5441 16.2805 17.0371 15.748 16.5576C15.4402 16.2805 15.4153 15.8059 15.6924 15.498ZM15 9.5C15 10.8132 14.2206 11.9434 13.0996 12.4561C13.5394 12.5767 13.9657 12.749 14.3711 12.9717L16.1474 11.4336C16.4605 11.1624 16.9348 11.1957 17.206 11.5088C17.4771 11.8218 17.4428 12.2952 17.1299 12.5664L8.26073 20.25H17.25C17.6642 20.25 18 20.5858 18 21C18 21.4142 17.6642 21.75 17.25 21.75H6.24999C5.93685 21.75 5.65628 21.5551 5.54686 21.2617C5.43774 20.9686 5.52245 20.6385 5.75878 20.4336L13.1338 14.0439C12.6854 13.8684 12.2154 13.7699 11.7402 13.7529C11.0027 13.7267 10.2675 13.8965 9.59569 14.252C8.92338 14.6077 8.33169 15.1404 7.87596 15.8115C7.42003 16.4831 7.11509 17.2718 6.99218 18.1094C6.93182 18.519 6.55029 18.8023 6.14061 18.7422C5.73103 18.6818 5.44768 18.3003 5.5078 17.8906C5.66259 16.8363 6.04797 15.8341 6.63475 14.9697C7.22177 14.105 7.99486 13.4014 8.89354 12.9258C9.33799 12.6906 9.80616 12.5146 10.2871 12.4014C9.22731 11.866 8.49999 10.7685 8.49999 9.5C8.49999 7.70507 9.95506 6.25 11.75 6.25C13.5449 6.25 15 7.70507 15 9.5Z" fill={iconColor}/>
      </g>
      <defs>
        <clipPath id="clip0_604_44">
          <rect width="24" height="24" rx="4" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default SeatbeltParkedIcon;
